import Canvas from './components/Canvas'

function App() {
  return (
    <>
      <Canvas />
    </>
  );
}

export default App;
